<template>
    <div>
        <div class="contrainer" v-if="invtemp==null && !loading">
            <div class="row">
                <div class="card col-md-4 my-3 mx-auto bg-secondary p-1">
                    <h4>Please select an Invoice Template:</h4>
                    <select v-model="invtemp" class="col-sm-12 col-md-6 form-select form-select-lg mb-3" aria-label=".form-select-lg example" @change.prevent="getInvoiceData()">
                        <option selected disabled>Open this select menu</option>
                        <option v-for="(temp,index) in ddHolder.invtemps" :key="index" :value="temp.id" :selected="temp.id==invtemp">{{ temp.name }}</option>            
                    </select>
                </div>


            </div>
        </div>
        <div class="container" v-else-if="invtemp!=null && !loading">

            <h1>Invoice Draft</h1>
            <div class="printblock border border-1 shadow p-3 mb-5 bg-white rounded mx-auto" >
                <div class="row g-0">
                    <!-- BILLER HEADER -->
                    <div class="col-12 py-0 bg-light px-1 rounded border border-1 shadow-sm mb-3">
                        <div class="container border-bottom border-1 mb-0">
                            <div class="row align-items-center">
                                <img
                                    v-if="showHeaderLogo"
                                    :src="headerLogoUrl"
                                    alt="logo"
                                    class="object-fit-contain col-4 pb-0"
                                    style="height: 2cm;"
                                >
                                <h3 :class="headerTitleClass">{{ headerTitle }}</h3>
                            </div>
                        </div>
                        <div class="row g-0">
                            <div class="col-8 p-1 border-end border-1">
                                <div class="d-flex flex-column align-items-start">
                                    <p class="m-0" style="text-align: justify;"><b>Address: </b>{{ billerAddress + ', ' + billerContact + ', ' + billerEmail }},</p>
                                    <p class="mb-1 mt-0 mx-0 " style="text-align: justify;"><b>PAN: </b> {{ billerPan }}, <b>GST: </b> {{ billerGst==null? 'N/A': billerGst }}</p>
                                    <p v-if="billerTaxDetails" class="mb-1 mt-0 mx-0 " style="text-align: justify;"><b>Note: </b> {{ billerTaxDetails }}</p>
                                </div>
                            </div>
                            <div class="col-4 d-xl-flex justify-content-xl-end align-items-xl-center px-3">
                                <div class="d-flex flex-column align-items-start">
                                <b>Invoice No:</b><input type="text" v-model="invoice.invoice_no"><b>Invoice Date:</b>{{getCurrentDate()}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- BILLER HEADER ENDS -->
                    <!-- PAYEE DETAILS -->
                    <div class="col-12 py-0 bg-light px-1 rounded border border-1 shadow-sm mb-3">
                        <div class="container border-bottom border-1 mb-0">
                            <h4 class="pb-0">Payee Details</h4>
                        </div>
                        <div class="row g-0">
                            <div class="col-12 p-1 ">
                                <div class="d-flex flex-column align-items-start">
                                    <p class="m-0" style="text-align: justify;"><b>Name: </b>{{ invoice['payee.name'] }}</p>
                                    <p class="m-0" style="text-align: left;"><b>Address: </b>{{ invoice['payee.address']+', '+invoice['payee.contact_no']+', '+invoice['payee.email'] }},</p>
                                    <p class="mb-1 mt-0 mx-0 " style="text-align: justify;"><b>PAN: </b> {{  invoice['payee.pan'] }}, <b>GST: </b> {{ invoice['payee.gst']==null? 'N/A': invoice['payee.gst']}}</p>
                                    <p v-if="invoice['payee.tax_details']" class="mb-1 mt-0 mx-0 " style="text-align: justify;"><b>Note: </b> {{ invoice['payee.tax_details'] }}</p>
                                </div>
                            </div>                            
                        </div>
                    </div>
                    <!-- PAYEE DETAILS END-->
                    <div class="col-12 px-1">
                        <!-- regular invoice table -->
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col" class="text-start" style="width: 80px;">#</th>
                                                              <th v-if="showHsn" scope="col" class="text-start">HSN / SAC</th>
                              <th scope="col" class="text-start">Description</th>
                              <th scope="col" class="text-end" >Qty</th>
                              <th scope="col" class="text-end" >Cost</th>
                              <th scope="col" class="text-end" >Sub Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(item,index) in invoice.billables" :key="index">
                              <tr>                                
                                <th scope="row" class="text-start" style="width: 80px;">{{ index+1 }}</th>
                                                                <td v-if="showHsn" class="text-start align-top">{{ item.hsn || '-' }}</td>
                                                                <td>
                                                                    <textarea class="form-control form-control-sm invoice-line-note" rows="2" v-model="item.description" placeholder="Line item description"></textarea>
                                                                </td>
                                <td class="d-flex justify-content-end" >
                                  <input class="text-end form-control" type="number" min="1" step="1" v-model="item.qty" @change.prevent="item.subTotal=item.qty*item.cost;setTotal();">
                                </td>
                                <td class="text-end" >
                                  <b>{{ curr[currency].symbol }}</b><input class="text-end form-control float-end" type="number" min=".00" step=".01" v-model="item.cost" @change.prevent="item.subTotal=item.qty*item.cost;setTotal();">
                                </td>
                                <td class="text-end" >{{ formatCurrency(item.subTotal) }}</td>                              
                              </tr>
                              <!-- Taxes row for this billable -->
                              <tr v-if="item.taxes && item.taxes.length > 0" class="table-light">
                                <td></td>
                                                                <td :colspan="showHsn ? 4 : 3" class="text-start"><small><b>Taxes:</b></small></td>
                                <td class="text-end">
                                  <div v-for="(tax, tidx) in item.taxes" :key="tidx" style="font-size: 0.9em;">
                                    <small>{{ tax.shortcode || tax.short || tax.name || tax }} ({{ getTaxPercentage(tax) }}%): {{ formatCurrency(calculateTaxAmount(item.subTotal, tax)) }}</small>
                                  </div>
                                </td>
                              </tr>
                              <!-- Amount with tax for this billable -->
                              <tr v-if="item.taxes && item.taxes.length > 0" class="table-light">
                                <td></td>
                                                                <td :colspan="showHsn ? 4 : 3" class="text-start"><small><b>Amount with Tax:</b></small></td>
                                <td class="text-end"><small><b>{{ formatCurrency(calculateBillableWithTax(item)) }}</b></small></td>
                              </tr>
                            </template>
                            <tr class="table-secondary text-white">
                                <td></td>
                                                                <th scope="row" class="text-start" :colspan="showHsn ? 4 : 3">Total (with all taxes) ===></th>
                              <td  class="text-end">
                                <b> {{ formatCurrency(getTotal) }}</b>
                            </td>
                            </tr>
                            <tr class="table-secondary text-white">
                                <td></td>
                                <td scope="row" class="text-start"  :colspan="showHsn ? 5 : 4">
                                    <b>In words: </b><i> {{ convertToWords(getTotal,currency) }}</i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                    <div class="col-12" >
                        <!-- <editor
                            api-key="kbkanx4ppai2u62smpu60i7k7xegfy894dl937j98vvcx060"
                            :init="{
                                height: 500,
                                menubar: true,
                                plugins: 'lists link image',
                                toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent',
                            }"
                            v-model="invoice.note"                             
                            /> -->
                        <termsinput v-if="invoice['terms']" :terms="invoice['terms']['delivery']" :title="'Terms Of Delivery'" @terms="invoice['terms']['delivery']=$event"/>
                        <hr/>
                        <termsinput v-if="invoice['terms']" :terms="invoice['terms']['payment']" :title="'Terms Of Payment'" @terms="invoice['terms']['payment']=$event"/>
                        <hr/>
                                                <div class="card mb-3">
                                                    <div class="card-header bg-secondary text-white fw-bold py-1">Note</div>
                                                    <div class="card-body p-2">
                                                        <textarea
                                                            class="form-control form-control-sm invoice-note-text"
                                                            rows="3"
                                                            placeholder="Additional note"
                                                            aria-label="Note"
                                                            v-model="invoice.note"
                                                        />
                                                    </div>
                        </div>
                    </div>
                    <!-- PAYEE SECTION -->
                    <div class="col-12 py-0 bg-light px-1 rounded border border-1 shadow-sm mb-3">
                        <div class="container border-bottom border-1 mb-0">
                            <h4 class="pb-0">Payment Option / Bank Details</h4>
                        </div>
                        <div class="row g-0">
                            <div class="col-12 p-1 ">
                                <div class="d-flex flex-column align-items-start">
                                    <p class="m-0 display-6" style="text-align: justify;font-size: initial;"><b>Bank Account </b></p>
                                    <p class="m-0" style="text-align: justify;"><b>Name on Account: </b>{{ invoice['bank_accounts.name'] }}</p>
                                    <p class="m-0" style="text-align: justify;"><b>Bank Name: </b>{{ invoice['bank_accounts.bank_branch.bank.name'] }},</p>
                                    <p class="m-0" style="text-align: justify;"><b>Account No.: </b>{{ invoice['bank_accounts.account_no'] }},</p>
                                    <p class="m-0" style="text-align: justify;"><b>IFSC Code: </b>{{ invoice['bank_accounts.bank_branch.ifsc'] }},</p>
                                </div>
                            </div>                            
                        </div>
                    </div>
                    <!-- PAYEE SECTION ENDS -->
                    <div class="col-12">
                        <div class="noprint d-flex align-items-center gap-3 mb-2">
                            <div class="form-check form-switch mb-0">
                                <input class="form-check-input" type="checkbox" id="showHsnToggleGen" v-model="showHsn">
                                  <label class="form-check-label" for="showHsnToggleGen">Show HSN / SAC in description</label>
                            </div>
                            <div class="form-check form-switch mb-0">
                                <input class="form-check-input" type="checkbox" id="roundTaxToggle" v-model="roundTax">
                                <label class="form-check-label" for="roundTaxToggle">Round tax amounts</label>
                            </div>
                        </div>
                         <div class="btn-group noprint" role="group" aria-label="Invoice Actions">
                                                     <button type="button" class="btn btn-primary" @click.prevent="requestActionCaptcha({ title: 'Confirm Generate', promptText: 'Solve the sum to generate and save this invoice.', confirmLabel: 'Generate', action: () => saveInvoice() })">Save</button>
                           <button type="button" class="btn btn-danger" @click.prevent="invtemp=null">Cancel</button>
                         </div>
                    </div>
                    
                </div>
                <!-- <div class="row" >
                    <div class="col-6">
                        
                        <p>Invoice for: {{ invoice.entity }}</p>
                        <p>Amount: {{ invoice.amount }}</p>
                        <p>Date: {{ invoice.date }}</p>
                    </div>
                    <div class="col-6">
                    </div> 
                </div> -->
            </div>
        </div>
        <ActionCaptchaModal
          :show="showActionCaptcha"
          :title="captchaTitle"
          :prompt-text="captchaPromptText"
          :confirm-label="captchaConfirmLabel"
          @close="closeActionCaptcha"
          @confirmed="confirmActionCaptcha"
        />
    </div>
</template>
<script>
import { convertToWords } from '@/parts/numwords';
import { dropDownLinks,invoiceLinks } from '@/cd-links';
import termsinput from '@/parts/termsinput.vue';
import ActionCaptchaModal from '@/components/mods/ActionCaptchaModal.vue';
/* import Editor from '@tinymce/tinymce-vue'; */
    export default {
        name: 'InvoiceView',
        components: {
            /* Editor, */ termsinput, ActionCaptchaModal
        },
        data() {
            return {
                editor: null,
                invtemp: null,
                loading: false,
                invoice: {
                    entity: 'Jaxx Corebin',
                    amount: 100,
                    date: new Date().toLocaleDateString()
                },
                ddHolder: {
                    invtemps: [],
                    payee: [],
                    tax: [],
                    billables: [],
                    recurrence: [],
                    bank_accounts: [],
                },
                total:0,
                roundTax: true,
                showHsn: false,
                showActionCaptcha: false,
                captchaTitle: 'Confirm Action',
                captchaPromptText: 'Please solve this quick check to continue.',
                captchaConfirmLabel: 'Confirm',
                pendingAction: null,
                currency:'INR',
                curr:{
                    'INR': {
                        name: 'Indian Rupee',
                        code: 'INR',
                        symbol: '₹'
                    },
                    'USD': {
                        name: 'United States Dollar',
                        code: 'USD',
                        symbol: '$'
                    },
                    'EUR': {
                        name: 'Euro',
                        code: 'EUR',
                        symbol: '€'
                    },
                    'GBP': {
                        name: 'British Pound Sterling',
                        code: 'GBP',
                        symbol: '£'
                    },
                    'AUD': {
                        name: 'Australian Dollar',
                        code: 'AUD',
                        symbol: 'A$'
                    },
                    'CAD': {
                        name: 'Canadian Dollar',
                        code: 'CAD',
                        symbol: 'C$'
                    },
                    'CHF': {
                        name: 'Swiss Franc',
                        code: 'CHF',
                        symbol: 'CHF'
                    },
                    'CNY': {
                        name: 'Chinese Yuan',
                        code: 'CNY',
                        symbol: '¥'
                    },
                    'JPY': {
                        name: 'Japanese Yen',
                        code: 'JPY',
                        symbol: '¥'
                    },
                    'NZD': {
                        name: 'New Zealand Dollar',
                        code: 'NZD',
                        symbol: 'NZ$'
                    },
                    'SEK': {
                        name: 'Swedish Krona',
                        code: 'SEK',
                        symbol: 'kr'
                    },
                    'RUB': {
                        name: 'Russian Ruble',
                        code: 'RUB',
                        symbol: '₽'
                    }
                },
                content: `
                        <table class="table table-striped table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th>Delivery Terms</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Cell 1</td>
                                </tr>
                                <tr>
                                    <td>Cell 3</td>
                                </tr>
                            </tbody>
                        </table>
                `,
            }
        },
        computed: {
            getEntity() {
                return this.$store.getters.getEntity;
            },
            getUser() {
                return this.$store.getters.getUser;
            },
            getTotal() {
                let grandTotal = 0;
                if (this.invoice.billables) {
                    this.invoice.billables.forEach(item => {
                        let itemTotal = Number(item.subTotal) || 0;
                        if (item.taxes && item.taxes.length > 0) {
                            item.taxes.forEach(tax => {
                                itemTotal += this.calculateTaxAmount(item.subTotal, tax);
                            });
                        }
                        grandTotal += itemTotal;
                    });
                }
                return grandTotal;
            },
            headerType() {
                return this.invoice['biller_header_type'] || 'entity_name_only';
            },
            headerLogoUrl() {
                return this.invoice['biller_header_logo_url'] || this.invoice['biller_header_logo_path'] || null;
            },
            showHeaderLogo() {
                return !!this.headerLogoUrl && ['logo_only', 'logo_entity_name', 'logo_custom_text'].includes(this.headerType);
            },
            billerName() {
                return this.invoice['biller_name'] || this.invoice['biller.name'] || '';
            },
            headerTitle() {
                switch (this.headerType) {
                    case 'logo_custom_text':
                    case 'custom_text_only':
                        return this.invoice['biller_header_custom_text'] || this.billerName;
                    case 'logo_only':
                    case 'logo_entity_name':
                    case 'entity_name_only':
                    default:
                        return this.billerName;
                }
            },
            headerTitleClass() {
                if (this.showHeaderLogo) {
                    return 'col-8 pb-0 text-start';
                }

                if (['entity_name_only', 'custom_text_only'].includes(this.headerType)) {
                    return 'col-12 pb-0 text-center';
                }

                return 'col-12 pb-0 text-start';
            },
            billerAddress() {
                return this.invoice['biller_address'] || this.invoice['biller.address'] || '';
            },
            billerContact() {
                return this.invoice['biller_contact_no'] || this.invoice['biller.contact_no'] || '';
            },
            billerEmail() {
                return this.invoice['biller_email'] || this.invoice['biller.email'] || '';
            },
            billerPan() {
                return this.invoice['biller_pan'] || this.invoice['biller.pan'] || '';
            },
            billerGst() {
                return this.invoice['biller_gst'] || this.invoice['biller.gst'] || null;
            },
            billerTaxDetails() {
                const val = this.invoice['biller_tax_details'] || this.invoice['biller.tax_details'];
                if (val == null) return '';
                if (typeof val === 'string') return val;
                try {
                    return JSON.stringify(val);
                } catch (_) {
                    return String(val);
                }
            },
        },
        methods: {
            requestActionCaptcha({ title, promptText, confirmLabel, action }) {
                this.captchaTitle = title || 'Confirm Action';
                this.captchaPromptText = promptText || 'Please solve this quick check to continue.';
                this.captchaConfirmLabel = confirmLabel || 'Confirm';
                this.pendingAction = typeof action === 'function' ? action : null;
                this.showActionCaptcha = true;
            },
            closeActionCaptcha() {
                this.showActionCaptcha = false;
                this.pendingAction = null;
            },
            confirmActionCaptcha() {
                const action = this.pendingAction;
                this.showActionCaptcha = false;
                this.pendingAction = null;
                if (typeof action === 'function') action();
            },

            setInvoiceNo(prefix,number) {
                const now = new Date();
                function getFY(){
                    return now.getFullYear() + "-" + (now.getFullYear()+1).toString().slice(-2);
                }
                function getFYQuarter(month) {
                    if (month >= 1 && month <= 3) return getFY() + "-Q4";
                    else if (month >= 4 && month <= 6) return getFY() + "-Q1";
                    else if (month >= 7 && month <= 9) return getFY() + "-Q2";
                    else return getFY() + "-Q3";
                }
                function getQuarter(month) {
                    if (month >= 1 && month <= 3) return getFY() + "-Q1";
                    else if (month >= 4 && month <= 6) return getFY() + "-Q2";
                    else if (month >= 7 && month <= 9) return getFY() + "-Q3";
                    else return getFY() + "-Q4";
                }
                if (prefix == null || prefix == undefined) prefix = "INV";
                switch (prefix) {
                    case '$FY':
                        this.invoice.invoice_no = getFY()+ "-" +String((number)).padStart(6,0);
                        break;
                    case '$CY':
                        this.invoice.invoice_no = now.getFullYear()+ "-" +String((number)).padStart(6,0);
                        break;
                    case '$CM':
                        this.invoice.invoice_no = String(now.getMonth()+1).padStart(2,0) + "-" + String((number)).padStart(6,0);
                        break;
                    case '$QTR':
                        this.invoice.invoice_no = getQuarter(now.getMonth()+1) + "-" + String((number)).padStart(6,0);
                        break;
                    case '$QTRFY':
                        this.invoice.invoice_no = getFYQuarter(now.getMonth()+1) + "-" + String((number)).padStart(6,0);
                        break;
                    default:
                        this.invoice.invoice_no = prefix+"-"+number;
                        break;
                }
                /* this.invoice.invoice_no = this.invoice['biller.invoice_prefix']+"-"+(this.invoice['biller.last_invoice_no']+1); */
            },
            formatCurrency(value) {
                        if (isNaN(value)) {
                            return "Invalid value";
                        }

                        const currencySymbol = this.curr[this.currency].symbol || "^"; // Default to ^ if currency not found
                        
                        // Formatting the value with commas
                        const formattedValue = this.currency!='INR'? value.toLocaleString("en-US",{ maximumFractionDigits: 2, minimumFractionDigits: 2 }) : value.toLocaleString("en-IN", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
                        
                        // Combining currency symbol and formatted value
                        return `${currencySymbol}${formattedValue}`;
            },
            convertToWords(num,curr) {
                return convertToWords(num,curr);
            },
            printInvoice() {
                window.print();
            },
            setTotal() {
                this.total = 0;
                for(let i=0;i<this.invoice.billables.length;i++){
                    /* console.log(this.invoice.billables[i]); */
                    this.total += Number(this.invoice.billables[i].subTotal);
                }                                
            },            
            calculateTaxAmount(subTotal, tax) {
                if (!tax) return 0;
                let percentage = 0;
                if (typeof tax === 'object' && tax.perc !== undefined) {
                    percentage = Number(tax.perc);
                } else if (typeof tax === 'object' && tax.percentage !== undefined) {
                    percentage = Number(tax.percentage);
                } else if (typeof tax === 'string') {
                    percentage = Number(tax);
                }
                const raw = (Number(subTotal) * percentage) / 100;
                return this.roundTax ? Math.round(raw) : raw;
            },
            calculateBillableWithTax(item) {
                let total = Number(item.subTotal) || 0;
                if (item.taxes && item.taxes.length > 0) {
                    item.taxes.forEach(tax => {
                        total += this.calculateTaxAmount(item.subTotal, tax);
                    });
                }
                return total;
            },
            getTaxPercentage(tax) {
                if (!tax) return 0;
                if (typeof tax === 'object' && tax.perc !== undefined) return Number(tax.perc);
                if (typeof tax === 'object' && tax.percentage !== undefined) return Number(tax.percentage);
                if (typeof tax === 'string') return Number(tax);
                return 0;
            },
            getCurrentDate() {
                    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    const today = new Date();
                    const day = String(today.getDate()).padStart(2, "0");
                    const month = months[today.getMonth()];
                    const year = today.getFullYear();
                    return `${day}-${month}-${year}`;
            },
            async saveInvoice(){
                let submitData = {};
                Object.keys(this.invoice).forEach(k=>{
                    switch (k.replaceAll(".","_")) {
                        case "bank_accounts_account_no":
                            submitData["bank_account_no"]=this.invoice[k]
                            break;
                        case "bank_accounts_bank_branch_bank_id":
                            submitData["bank_id"]=this.invoice[k]
                            break;
                        case "bank_accounts_bank_branch_bank_name":
                            submitData["bank_name"]=this.invoice[k]
                            break;
                        case "bank_accounts_bank_branch_id":
                            submitData["bank_branch_id"]=this.invoice[k]
                            break;
                        case "bank_accounts_id":
                            submitData["bank_account_id"]=this.invoice[k]
                            break;
                        case "bank_accounts_name":
                            submitData["bank_account_name"]=this.invoice[k]
                            break;
                        case "bank_accounts_bank_branch_name":
                            submitData["bank_branch_name"]=this.invoice[k]
                            break;
                        case "bank_accounts_bank_branch_ifsc":
                            submitData["bank_branch_ifsc"]=this.invoice[k]
                            break;
                        default:
                            submitData[k.replaceAll(".","_")]=this.invoice[k]
                            break;
                    }
                });
                submitData.terms = this.sanitizeTermsPayload(submitData.terms);
                submitData['template_id'] = submitData.id;
                delete submitData.id;
                console.log("=============Data to be submitted==============");
                console.log(submitData);
                console.log("===============================================");
                this.loading=true;
                await this.$store.getters.getAxios.post(invoiceLinks.post,submitData)
                    .then(resp=>{
                        if(!resp.data.isLoggedIn){
                            this.$store.dispatch('loggedOut');
                        }
                        else {
                            this.invoice =  resp.data.data;
                            this.$store.commit('addAlert', {
                                title: resp.data.title,
                                message: resp.data.msg,
                                type: resp.data.success? 'success' : 'danger'
                            });
                        }
                        this.invtemp = null;
                    })
                    // eslint-disable-next-line
                    .catch(err=>{
                        this.$store.commit('addAlert', {
                            title: "Error Saving Invoice",
                            message: "Try after some time",
                            type: 'danger'
                        });
        
                    });
                this.loading=false;
            },
            async getDropDownData(table,listName,filter) {
                    this.loading=true;
                    await this.$store.getters.getAxios.post(dropDownLinks[table],{ent_id:this.$store.getters.getEntity,filter:filter})
                        .then(resp=>{
                            if(!resp.data.isLoggedIn){
                                this.$store.dispatch('loggedOut');
                            }
                            else this.ddHolder[listName] =  resp.data.data;
                            this.loading=false;
                        })
                        // eslint-disable-next-line
                        .catch(err=>{
                            this.$store.commit('addAlert', {
                                title: "Error Getting DropDown Data for "+listName,
                                message: "Try after some time",
                                type: 'danger'
                            });
        
                        })
            },
            async getInvoiceData() {
                this.loading=true;
                await this.$store.getters.getAxios.post(invoiceLinks.generate,{biller_id:this.$store.getters.getEntity,template_id:this.invtemp})
                    .then(resp=>{
                        if(!resp.data.isLoggedIn){
                            this.$store.dispatch('loggedOut');
                        }
                        else {
                            this.invoice =  resp.data.data;
                            this.invoice.billables.forEach(item => {
                                item['qty'] = 1;
                                item['subTotal'] = item.qty * item.cost;
                                this.currency = item.currency;
                            });                            
                            this.setTotal();
                            this.invoice.terms==null? this.invoice.terms = {delivery:'',payment:''}: this.invoice.terms;
                            if(this.invoice.terms['delivery'] == undefined || this.invoice.terms['delivery']==null) this.invoice.terms['delivery']=[];
                            if(this.invoice.terms['payment'] == undefined || this.invoice.terms['payment']==null) this.invoice.terms['payment']=[];
                            this.invoice.terms = this.sanitizeTermsPayload(this.invoice.terms, false);
                            /* this.invoice['invoice_no']=this.invoice['biller.invoice_prefix']+"-"+(this.invoice['biller.last_invoice_no']+1); */
                            this.setInvoiceNo(this.invoice['biller.invoice_prefix'],Number(this.invoice['biller.last_invoice_no'])+1);                            
                        }
                        this.$store.commit('addAlert', {
                            title: resp.data.title,
                            message: resp.data.msg,
                            type: resp.data.success? 'info' : 'danger'
                        });
                        this.loading=false;
                    })
                    // eslint-disable-next-line
                    .catch(err=>{
                        this.$store.commit('addAlert', {
                            title: "Error Getting Invoice Data",
                            message: "Try after some time",
                            type: 'danger'
                        });
        
                    })
            },
            normalizeTermList(terms, removeEmpty = true) {
                if (!Array.isArray(terms)) return [];
                const normalized = terms.map((term) => String(term ?? '').trim());
                return removeEmpty ? normalized.filter((term) => term.length > 0) : normalized;
            },
            sanitizeTermsPayload(terms, removeEmpty = true) {
                const source = terms && typeof terms === 'object' ? terms : {};
                return {
                    delivery: this.normalizeTermList(source.delivery, removeEmpty),
                    payment: this.normalizeTermList(source.payment, removeEmpty)
                };
            }
        },
        mounted() {
            /* this.getDropDownData('accounts','accounts',0);
            this.getDropDownData('pentities','pentities',0);
            this.getDropDownData('taxes','taxes',0);
            this.getDropDownData('billables','billabes',0); */
            this.getDropDownData('invtemps','invtemps',0);
        }
    }
</script>
<style scoped>
[type="number"] {
    /* max-width: 300px; */ /* Set the maximum width */
    /* width: 100%; */ /* Make it responsive */
    max-width: 100px !important; /* Set the maximum width */
}
.printblock{
    font-size: 3mm !important;
    width: 210mm; /* A4 width */
    /* height: 297mm; */ /* A4 height */
    /* padding: 10mm; */ /* Optional: content padding */
  }
.invoice-line-note,
.invoice-note-text {
    font-size: 0.72rem;
    line-height: 1.25;
    white-space: pre-line;
    text-align: left;
}
@media print {
  body{
    visibility: hidden;
  }
  .noprint{
    display: none !important;
  }
  .printblock{
    visibility: visible;
    position: absolute;
    top: 0;
    left: 0;
    page-break-after: always; /* Force page break after each A4 block */
  }
}
</style>